<template>
    <v-container
        fluid
        class="px-4"
        v-if="saleAgent">
        <v-row>
            <!-- <detail-form-item
                cols="6"
                :label="$t('saleAgent.details.name')"
                :value="saleAgent.name"
                :disabled="true"> -->
            <v-col cols="4" class="mt-2">
                <div
                    class="subtitle-2 pb-2 font-weight-bold"
                    v-html="$t('saleAgent.details.name')"/>
                <template >
                    <div>{{ saleAgent.name }}</div>
                </template>
            <!-- </detail-form-item> -->
            </v-col>

            <!-- <detail-form-item
                cols="6"
                :label="$t('saleAgent.details.id')"
                :value="saleAgent.id"
                :disabled="true"> -->
            <v-col cols="4" class="mt-2">
                <div
                    class="subtitle-2 pb-2 font-weight-bold"
                    v-html="$t('saleAgent.details.id')"/>
                <template >
                    <div>{{ saleAgent.id }}</div>
                </template>
            <!-- </detail-form-item> -->
            </v-col>

            <v-col cols="4" class="mt-2">
                <div
                    class="subtitle-2 pb-2 font-weight-bold"
                    v-html="$t('saleAgent.details.commission')"/>
                <template >
                    <div class="d-flex flex-row">
                        <p class="mr-2">{{ saleAgent.commission }}</p>
                        <p v-if="saleAgent.commissionType == 'bath'">THB</p>
                        <p v-if="saleAgent.commissionType == 'percent'">%</p>
                    </div>
                </template>
            <!-- </detail-form-item> -->
            </v-col>

            <v-col cols="12">
                <sale-booking-history-table
                    :items="saleAgent.saleHistory"
                    @viewDetails="setData"
                    @onChageSelect="submitStatus"
                />
            </v-col>
        </v-row>
    </v-container>
    <div v-else></div>
</template>

<script>
// import DetailFormItem from '@/components/forms/DetailFormItem'
import SaleBookingHistoryTable from '@/components/tables/SaleBookingHistoryTable'
import { mapState } from 'vuex'

export default {
    name: 'SaleAgentPersonDetailsView',

    components: {
        // DetailFormItem,
        SaleBookingHistoryTable
    },

    computed: {
        ...mapState('saleagentByPerson', ['orderlist', 'orderDetail'])
    },

    props: {
        saleAgent: {
            type: Object,
            default: () => ({})
        }
    },

    methods: {
        submitStatus (value) {
            // this.$store.state.orderDetail.isPaid = value
            this.patchSaleAgent()
        },

        setData (value) {
            this.$store.commit('saleagentByPerson/setOrderDetail', value)
            console.log(this.$store.state)
        },

        patchSaleAgent () {
            this.$store.dispatch('saleagentByPerson/patchOrderDetail')
                .then((res) => {
                    console.log(res)
                    this.$store.dispatch('saleagentList/fetchOrderlist')
                    this.$emit('closeRightPanel', true)
                })
        }
    }
}
</script>

<style lang="scss" scoped>

</style>
